import React from "react";
import { Link } from "react-router-dom";
import paths from "../../routes/paths";
import { imageCodes, titleCodes, textCodes, videoCodes } from '../../template_codes/synergy/portfolio_page_codes';

function Portfolio() {
    return (
        <div>
            {/*             banner image           */}
            <div className="w-full bg-cover pt-10 bg-transparent"
                style={{ backgroundImage: `url(${imageCodes.banner.image})` }}
            >
                <div className="overlay text-center py-32 bg-overlay">
                    <div className="container w-5/6 bg-[#ffffff80] pb-2 mb-8 ">
                        <h1 className="text-6xl text-center font-bold py-4 text-slate-700">{titleCodes.synergy.title}</h1>
                        <p className="pb-4 text-center text-xl font-semibold text-slate-600">{textCodes.est.text}</p>

                    </div>

                </div>
            </div>
            {/*           end of banner image           */}


            {/*           about image           */}
            <div className="container w-4/5 pt-14">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-2 gap-8">
                    <div className="">
                        <img src={imageCodes.aboutSynergy.image} alt="Synergy Garment" className="rounded-lg transition-transform duration-700 ..."></img>
                    </div>
                    <div className="pt-4">
                        <p className="text-md">{textCodes.est.text}</p>
                        <h1 className="font-bold text-4xl pb-8 text-gray-700">{titleCodes.synergy.title}</h1>

                        <p className="pb-4 text-gray-500">{textCodes.about1.text}</p>
                        <p className="pb-8 text-gray-500">{textCodes.about2.text}</p>

                        <Link to={paths.about}>
                            <button className="btn glass bg-black hover:bg-cyan-700 btn-sm sm:btn-sm md:btn-md lg:btn-md xl:btn-md 2xl:btn-md">
                                <p className="text-sm hover:tracking-wider px-4">View more</p>
                            </button>
                        </Link>
                    </div>
                </div>
            </div>
            {/*           end of about image           */}

            {/*           factory process           */}
            <div className="py-14">
                <h1 className="font-bold text-3xl pb-8 text-center">{titleCodes.factory.title}</h1>

                <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-3">
                    <div className="p-4 bg-base-200 text-base-content">
                        <h2 className="text-cyan-900 font-semibold text-2xl pt-8 text-center">{titleCodes.warehouse.title}</h2>
                        <p className="text-center text-lg py-2">{textCodes.about1.text}</p>
                    </div>
                    <div>
                        <img src={imageCodes.process1.image} alt="Process" className="rounded-md hover:opacity-75 ..."></img>
                    </div>
                    <div className="p-4 bg-base-200 text-base-content">
                        <h2 className="text-cyan-900 font-semibold text-xl pt-8 text-center">{titleCodes.pattern.title}</h2>
                        <p className="text-center text-lg py-2">{textCodes.about1.text}</p>
                    </div>
                    <div>
                        <img src={imageCodes.process2.image} alt="Process" className="rounded-md hover:opacity-75 ..."></img>
                    </div>
                    <div className="p-4 bg-base-200 text-base-content">
                        <h2 className="text-cyan-900 font-semibold text-xl pt-8 text-center">{titleCodes.cutting.title}</h2>
                        <p className="text-center text-lg py-2">{textCodes.cuttingText.text}</p>
                    </div>
                    <div>
                        <img src={imageCodes.process3.image} alt="Process" className="rounded-md hover:opacity-75 ..."></img>
                    </div>
                    <div className="p-4 bg-base-200 text-base-content">
                        <h2 className="text-cyan-900 font-semibold text-xl pt-8 text-center">{titleCodes.sewing.title}</h2>
                        <p className="text-center text-lg py-2">{textCodes.about1.text}</p>
                    </div>
                    <div>
                        <img src={imageCodes.process4.image} alt="Process" className="rounded-md hover:opacity-75 ..."></img>
                    </div>
                    <div className="p-4 bg-base-200 text-base-content">
                        <h2 className="text-cyan-900 font-semibold text-xl pt-8 text-center">{titleCodes.finishing.title}</h2>
                        <p className="text-center text-lg py-2">{textCodes.about1.text}</p>
                    </div>
                </div>
            </div>
            {/*           end of factory process           */}


            {/*           client's logo           */}
            <div className="container w-4/5 py-8">
                <p className="text-sm text-center">{textCodes.clients.text}</p>
                <h1 className="font-bold text-3xl pb-8 text-center">{titleCodes.clientTitle.title}</h1>

                <div className="grid grid-cols-4 gap-0">
                    <div className="p-2">
                        <img src={imageCodes.client1.image} alt="Client Logo" width={106} height={86} className="rounded-md hover:opacity-75 ..." />
                    </div>
                    <div className="p-2">
                        <img src={imageCodes.client2.image} alt="Client Logo" width={106} height={86} className="rounded-md hover:opacity-75 ..." />
                    </div>
                    <div className="p-2">
                        <img src={imageCodes.client3.image} alt="Client Logo" width={106} height={86} className="rounded-md hover:opacity-75 ..." />
                    </div>
                    <div className="p-2">
                        <img src={imageCodes.client5.image} alt="Client Logo" width={116} height={106} className="rounded-md hover:opacity-75 ..." />
                    </div>
                </div>
            </div>
            {/*           end of client's logo           */}


            {/*           youtube video           */}
            
            <div className="container w-full xl:w-4/6 lg:w-4/6">
                <embed src={videoCodes.video1.video} title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen
                    className="w-full h-80 md:h-screen lg:h-screen xl:h-screen 2xl:h-screen md:py-16 lg:py-16 xl:py-16 2xl:py-16">
                </embed>
            </div>
            {/*           end of youtube video           */}

            {/*           get in touch           */}
            <div className="container md:w-4/6 lg:w-4/6 xl:w-4/6 2xl:w-4/6 py-10 px-2">
                <div class="container flex justify-between items-center gap-4">
                    <div class="space-y-1">
                        <p class="text-gray-700 text-center text-xl font-semibold">
                            {titleCodes.getTouch.title}
                        </p>
                    </div>
                    <Link to={paths.contact}>
                        <button className="btn glass bg-black hover:bg-cyan-700 btn-md">
                            <p className="text-sm hover:tracking-wider px-2">{textCodes.contactButton.text}</p>
                        </button>
                    </Link>
                </div>
            </div>
            {/*           end of get in touch           */}
        </div >
    );
}

export default Portfolio;